import { FC, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MaterialIcon } from './material_icon';
import './menu.css';
import { useUserContext } from '../../contexts/user_context';

export interface MenuItem {
    path: string;
    label: string;
    icon: string;
    badge?: string;
}

interface Props {
    items: MenuItem[];
}

export const Menu: FC<Props> = ({ items }) => {
    const location = useLocation();
    const { spins, access_token } = useUserContext();

    // <span className='badge bounce'>Spins: {spins}</span>

    const get_badge = useCallback(
        (badge: string) => {
            switch (badge) {
                case 'spins':
                    return access_token ? <span className='badge bounce sm'>Spins: {spins}</span> : null;
                default:
                    return null;
            }
        },
        [access_token, spins]
    );

    return (
        <menu>
            {items.map(({ path, label, icon, badge }, index) => (
                <Link key={index} data-is-active={String(Number(location.pathname === path))} to={path}>
                    <MaterialIcon icon={icon} />
                    <span>{label}</span>
                    {badge && get_badge(badge)}
                </Link>
            ))}
        </menu>
    );
};
